import type { RouteRecordRaw } from 'vue-router'
import { AppModule } from '@/config/types'

import { CarrierLookupRoutes } from '@/routes/user/lookup/types'
import { getCarrierLookupDetailsRoutes } from '@/routes/user/lookup/carrierLookupDetails'

export const getCarrierLookupRoutes = (): RouteRecordRaw[] => [
  {
    name: CarrierLookupRoutes.index,
    path: 'carrier-lookup',
    meta: {
      permission: 'carrierLookup',
      modules: [AppModule.CarrierLookup, AppModule.CarrierLookupSession, AppModule.Compose],
    },
    component: () => import('@/components/views/services/carrierLookup/CarrierLookupNew.vue'),
    redirect: { name: CarrierLookupRoutes.singleLookup },
    children: [
      {
        name: CarrierLookupRoutes.singleLookup,
        path: '',
        component: () => import('@/components/views/services/carrierLookup/CarrierLookupSingle.vue'),
        props: { tab: true },
        meta: {
          tabTitle: 'pageTabTitle.user.services.carrierLookup.singleLookup',
        },
      },
      {
        name: CarrierLookupRoutes.bulkLookup,
        path: 'bulk-lookup',
        component: () => import('@/components/views/services/carrierLookup/CarrierLookupBulk.vue'),
        meta: {
          tabTitle: 'pageTabTitle.user.services.carrierLookup.bulkLookup',
        },
      },
      {
        name: CarrierLookupRoutes.history,
        path: 'history',
        meta: {
          tabTitle: 'pageTabTitle.user.services.carrierLookup.history',
        },
        component: () => import('@/components/views/services/carrierLookup/CarrierLookupHistory.vue'),
      },
    ],
  },
  ...getCarrierLookupDetailsRoutes(),
]
